import * as Colors from "./environmentColors";

export const slotBackground = {
    backgroundColor: Colors.primary,
    color: "white",

    borderRadius: "25px",

    padding: "30px",
    fontSize: "18px",
    marginTop: "10px"
};
